export var ContentType = /*#__PURE__*/function (ContentType) {
  ContentType["PAGE"] = "PAGE";
  ContentType["FOLDER"] = "FOLDER";
  return ContentType;
}({});